import { IconProps } from "./icon.type";

export function IcBotSparkle({ ...props }: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6709 18.6665C24.0648 18.6665 24.4549 18.7441 24.8189 18.8949C25.1829 19.0456 25.5136 19.2666 25.7922 19.5452C26.0708 19.8238 26.2917 20.1545 26.4425 20.5185C26.5933 20.8824 26.6709 21.2725 26.6709 21.6665V22.8732C26.6709 23.5937 26.5151 24.3057 26.2144 24.9604C25.9136 25.6151 25.4748 26.1971 24.9282 26.6665C22.8402 28.4585 19.8535 29.3345 16.0002 29.3345C12.1469 29.3345 9.16287 28.4585 7.07887 26.6678C6.53289 26.1983 6.09476 25.6165 5.79445 24.962C5.49414 24.3075 5.33874 23.5959 5.33887 22.8758V21.6665C5.33887 20.8709 5.65494 20.1078 6.21755 19.5452C6.78016 18.9826 7.54322 18.6665 8.33887 18.6665H23.6709Z"
        fill="url(#paint0_radial_2360_903)"
      />
      <path
        d="M23.6709 18.6665C24.0648 18.6665 24.4549 18.7441 24.8189 18.8949C25.1829 19.0456 25.5136 19.2666 25.7922 19.5452C26.0708 19.8238 26.2917 20.1545 26.4425 20.5185C26.5933 20.8824 26.6709 21.2725 26.6709 21.6665V22.8732C26.6709 23.5937 26.5151 24.3057 26.2144 24.9604C25.9136 25.6151 25.4748 26.1971 24.9282 26.6665C22.8402 28.4585 19.8535 29.3345 16.0002 29.3345C12.1469 29.3345 9.16287 28.4585 7.07887 26.6678C6.53289 26.1983 6.09476 25.6165 5.79445 24.962C5.49414 24.3075 5.33874 23.5959 5.33887 22.8758V21.6665C5.33887 20.8709 5.65494 20.1078 6.21755 19.5452C6.78016 18.9826 7.54322 18.6665 8.33887 18.6665H23.6709Z"
        fill="url(#paint1_linear_2360_903)"
      />
      <path
        d="M23.6709 18.6665C24.0648 18.6665 24.4549 18.7441 24.8189 18.8949C25.1829 19.0456 25.5136 19.2666 25.7922 19.5452C26.0708 19.8238 26.2917 20.1545 26.4425 20.5185C26.5933 20.8824 26.6709 21.2725 26.6709 21.6665V22.8732C26.6709 23.5937 26.5151 24.3057 26.2144 24.9604C25.9136 25.6151 25.4748 26.1971 24.9282 26.6665C22.8402 28.4585 19.8535 29.3345 16.0002 29.3345C12.1469 29.3345 9.16287 28.4585 7.07887 26.6678C6.53289 26.1983 6.09476 25.6165 5.79445 24.962C5.49414 24.3075 5.33874 23.5959 5.33887 22.8758V21.6665C5.33887 20.8709 5.65494 20.1078 6.21755 19.5452C6.78016 18.9826 7.54322 18.6665 8.33887 18.6665H23.6709Z"
        fill="url(#paint2_radial_2360_903)"
      />
      <path
        d="M23.6709 18.6665C24.0648 18.6665 24.4549 18.7441 24.8189 18.8949C25.1829 19.0456 25.5136 19.2666 25.7922 19.5452C26.0708 19.8238 26.2917 20.1545 26.4425 20.5185C26.5933 20.8824 26.6709 21.2725 26.6709 21.6665V22.8732C26.6709 23.5937 26.5151 24.3057 26.2144 24.9604C25.9136 25.6151 25.4748 26.1971 24.9282 26.6665C22.8402 28.4585 19.8535 29.3345 16.0002 29.3345C12.1469 29.3345 9.16287 28.4585 7.07887 26.6678C6.53289 26.1983 6.09476 25.6165 5.79445 24.962C5.49414 24.3075 5.33874 23.5959 5.33887 22.8758V21.6665C5.33887 20.8709 5.65494 20.1078 6.21755 19.5452C6.78016 18.9826 7.54322 18.6665 8.33887 18.6665H23.6709Z"
        fill="url(#paint3_radial_2360_903)"
      />
      <path
        d="M23.6709 18.6665C24.0648 18.6665 24.4549 18.7441 24.8189 18.8949C25.1829 19.0456 25.5136 19.2666 25.7922 19.5452C26.0708 19.8238 26.2917 20.1545 26.4425 20.5185C26.5933 20.8824 26.6709 21.2725 26.6709 21.6665V22.8732C26.6709 23.5937 26.5151 24.3057 26.2144 24.9604C25.9136 25.6151 25.4748 26.1971 24.9282 26.6665C22.8402 28.4585 19.8535 29.3345 16.0002 29.3345C12.1469 29.3345 9.16287 28.4585 7.07887 26.6678C6.53289 26.1983 6.09476 25.6165 5.79445 24.962C5.49414 24.3075 5.33874 23.5959 5.33887 22.8758V21.6665C5.33887 20.8709 5.65494 20.1078 6.21755 19.5452C6.78016 18.9826 7.54322 18.6665 8.33887 18.6665H23.6709Z"
        fill="url(#paint4_radial_2360_903)"
      />
      <path
        d="M16.0005 3.33325L15.8645 3.34259C15.6251 3.37545 15.4057 3.49389 15.2469 3.67601C15.0881 3.85813 15.0006 4.0916 15.0005 4.33325L14.9912 6.66658H16.9912L17.0005 4.33325L16.9912 4.19725C16.9583 3.95785 16.8399 3.73844 16.6578 3.57961C16.4757 3.42078 16.2422 3.33326 16.0005 3.33325Z"
        fill="url(#paint5_linear_2360_903)"
      />
      <path
        d="M24 8.33325C24 7.5376 23.6839 6.77454 23.1213 6.21193C22.5587 5.64932 21.7956 5.33325 21 5.33325H11C10.2044 5.33325 9.44129 5.64932 8.87868 6.21193C8.31607 6.77454 8 7.5376 8 8.33325V12.9999C8 13.7956 8.31607 14.5586 8.87868 15.1212C9.44129 15.6838 10.2044 15.9999 11 15.9999H21C21.7956 15.9999 22.5587 15.6838 23.1213 15.1212C23.6839 14.5586 24 13.7956 24 12.9999V8.33325Z"
        fill="url(#paint6_radial_2360_903)"
      />
      <path
        d="M18.9892 8.66595C18.7664 8.65965 18.5447 8.69808 18.3371 8.77897C18.1294 8.85986 17.9401 8.98156 17.7803 9.13689C17.6205 9.29222 17.4935 9.47801 17.4068 9.68327C17.3201 9.88854 17.2754 10.1091 17.2754 10.3319C17.2754 10.5548 17.3201 10.7754 17.4068 10.9806C17.4935 11.1859 17.6205 11.3717 17.7803 11.527C17.9401 11.6823 18.1294 11.804 18.3371 11.8849C18.5447 11.9658 18.7664 12.0043 18.9892 11.9979C19.4229 11.9857 19.8347 11.8048 20.1371 11.4937C20.4395 11.1826 20.6087 10.7658 20.6087 10.3319C20.6087 9.89808 20.4395 9.48132 20.1371 9.17022C19.8347 8.85913 19.4229 8.67822 18.9892 8.66595Z"
        fill="url(#paint7_linear_2360_903)"
      />
      <path
        d="M12.9999 8.66595C12.7772 8.65965 12.5554 8.69808 12.3478 8.77897C12.1402 8.85986 11.9509 8.98156 11.7911 9.13689C11.6313 9.29222 11.5043 9.47801 11.4175 9.68327C11.3308 9.88854 11.2861 10.1091 11.2861 10.3319C11.2861 10.5548 11.3308 10.7754 11.4175 10.9806C11.5043 11.1859 11.6313 11.3717 11.7911 11.527C11.9509 11.6823 12.1402 11.804 12.3478 11.8849C12.5554 11.9658 12.7772 12.0043 12.9999 11.9979C13.4336 11.9857 13.8454 11.8048 14.1479 11.4937C14.4503 11.1826 14.6195 10.7658 14.6195 10.3319C14.6195 9.89808 14.4503 9.48132 14.1479 9.17022C13.8454 8.85913 13.4336 8.67822 12.9999 8.66595Z"
        fill="url(#paint8_linear_2360_903)"
      />
      <path
        d="M30.6905 27.9531L31.7105 28.2838L31.7305 28.2891C31.7893 28.3099 31.8425 28.344 31.886 28.3888C31.9294 28.4335 31.9619 28.4877 31.9809 28.5471C31.9999 28.6065 32.0048 28.6695 31.9954 28.7312C31.986 28.7928 31.9624 28.8515 31.9265 28.9025C31.8781 28.9707 31.8096 29.0219 31.7305 29.0491L30.7105 29.3798C30.4001 29.4831 30.118 29.6572 29.8866 29.8884C29.6552 30.1196 29.4808 30.4015 29.3772 30.7118L29.0465 31.7305C29.0189 31.8092 28.9675 31.8775 28.8995 31.9258C28.8314 31.974 28.75 32 28.6665 32C28.5831 32 28.5017 31.974 28.4336 31.9258C28.3655 31.8775 28.3141 31.8092 28.2865 31.7305L27.9545 30.7118C27.8516 30.4009 27.6777 30.1183 27.4464 29.8864C27.2152 29.6545 26.9331 29.4797 26.6225 29.3758L25.6025 29.0438C25.5437 29.0231 25.4905 28.989 25.4471 28.9442C25.4036 28.8994 25.3712 28.8452 25.3522 28.7858C25.3332 28.7264 25.3282 28.6634 25.3377 28.6018C25.3471 28.5401 25.3707 28.4815 25.4065 28.4305C25.4549 28.3623 25.5235 28.311 25.6025 28.2838L26.6225 27.9531C26.9288 27.8472 27.2066 27.672 27.4341 27.4412C27.6617 27.2105 27.8329 26.9303 27.9345 26.6225L28.2665 25.6025C28.2941 25.5237 28.3455 25.4555 28.4136 25.4072C28.4817 25.3589 28.5631 25.333 28.6465 25.333C28.73 25.333 28.8114 25.3589 28.8795 25.4072C28.9475 25.4555 28.9989 25.5237 29.0265 25.6025L29.3585 26.6211C29.462 26.9313 29.6362 27.2131 29.8674 27.4443C30.0985 27.6755 30.3804 27.8497 30.6905 27.9531Z"
        fill="url(#paint9_linear_2360_903)"
      />
      <path
        d="M21.1387 22.8618C21.5542 23.2795 21.8668 23.7879 22.052 24.3472L22.6494 26.1832C22.6993 26.3247 22.7919 26.4472 22.9144 26.5339C23.0369 26.6206 23.1833 26.6671 23.3334 26.6671C23.4834 26.6671 23.6298 26.6206 23.7523 26.5339C23.8748 26.4472 23.9674 26.3247 24.0174 26.1832L24.6147 24.3472C24.8009 23.7892 25.1145 23.2824 25.5306 22.8667C25.9467 22.4511 26.4539 22.138 27.012 21.9525L28.8494 21.3552C28.9898 21.3043 29.1112 21.2115 29.197 21.0892C29.2828 20.9669 29.3289 20.8212 29.3289 20.6718C29.3289 20.5225 29.2828 20.3767 29.197 20.2544C29.1112 20.1322 28.9898 20.0393 28.8494 19.9885L28.812 19.9792L26.9747 19.3818C26.4166 19.1963 25.9094 18.8833 25.4932 18.4676C25.0771 18.0519 24.7635 17.5451 24.5774 16.9872L23.9814 15.1512C23.9317 15.0092 23.8391 14.8861 23.7165 14.7991C23.5938 14.712 23.4471 14.6653 23.2967 14.6653C23.1463 14.6653 22.9996 14.712 22.8769 14.7991C22.7543 14.8861 22.6617 15.0092 22.612 15.1512L22.0147 16.9872L22 17.0325C21.8132 17.5765 21.5049 18.0708 21.0985 18.4779C20.6922 18.8849 20.1984 19.1941 19.6547 19.3818L17.8174 19.9792C17.6769 20.03 17.5555 20.1228 17.4697 20.2451C17.3839 20.3674 17.3379 20.5131 17.3379 20.6625C17.3379 20.8119 17.3839 20.9576 17.4697 21.0799C17.5555 21.2022 17.6769 21.295 17.8174 21.3458L19.6547 21.9432C20.2147 22.1298 20.7214 22.4445 21.1387 22.8618Z"
        fill="url(#paint10_linear_2360_903)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_2360_903"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0.414868 15.3838) rotate(30.4076) scale(29.6703 47.26)"
        >
          <stop stopColor="#F08AF4" />
          <stop offset="0.535" stopColor="#9C6CFE" />
          <stop offset="1" stopColor="#4E44DB" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_2360_903"
          x1="16.0042"
          y1="17.3958"
          x2="20.8309"
          y2="35.4305"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#885EDB" stopOpacity="0" />
          <stop offset="1" stopColor="#E362F8" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_2360_903"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23.3895 23.5905) rotate(-90) scale(4.92379 2.79479)"
        >
          <stop stopColor="#4E44DB" />
          <stop offset="1" stopColor="#4E44DB" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_2360_903"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.5687 21.9492) rotate(-134.995) scale(4.64179 3.48133)"
        >
          <stop stopColor="#4E44DB" />
          <stop offset="1" stopColor="#4E44DB" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_2360_903"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23.3895 21.1278) rotate(180) scale(7.38439 2.89785)"
        >
          <stop stopColor="#4E44DB" />
          <stop offset="1" stopColor="#4E44DB" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint5_linear_2360_903"
          x1="14.9459"
          y1="2.66659"
          x2="17.3125"
          y2="5.16125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B52F4" />
          <stop offset="1" stopColor="#3D35B1" />
        </linearGradient>
        <radialGradient
          id="paint6_radial_2360_903"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.4 0.761253) rotate(37.6946) scale(26.6656 50.3741)"
        >
          <stop stopColor="#F08AF4" />
          <stop offset="0.535" stopColor="#9C6CFE" />
          <stop offset="1" stopColor="#4E44DB" />
        </radialGradient>
        <linearGradient
          id="paint7_linear_2360_903"
          x1="18.1132"
          y1="8.79395"
          x2="20.6385"
          y2="13.1526"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFDFD" />
          <stop offset="1" stopColor="#F9DCFA" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2360_903"
          x1="12.1226"
          y1="8.79395"
          x2="14.6479"
          y2="13.1526"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFDFD" />
          <stop offset="1" stopColor="#F9DCFA" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2360_903"
          x1="26.6665"
          y1="25.9998"
          x2="30.6692"
          y2="31.3318"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFA43D" />
          <stop offset="1" stopColor="#FB5937" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2360_903"
          x1="26.7614"
          y1="24.9525"
          x2="18.3467"
          y2="15.2765"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8A69" />
          <stop offset="1" stopColor="#FFCD0F" />
        </linearGradient>
      </defs>
    </svg>
  );
}
